import type { ButtonType } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";

import { MODAL_TEXTS } from "../../../texts";

export const getButtonsConfig = () => ({
    cancel: {
        label: translate(MODAL_TEXTS.buttonCancel),
        type: "flatDark" as ButtonType,
    },
    deleteTopicWithKW: {
        label: translate(MODAL_TEXTS.buttonDeleteList),
        type: "flatWarning" as ButtonType,
    },
    deleteTopic: {
        label: translate(MODAL_TEXTS.buttonRemove),
        type: "warning" as ButtonType,
    },
});
